import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { fleetEnvironment } from './fleet-environment';
import { availableRegionsSchema } from './schemas/available-regions.schema';

export function getMapSetsAvailableRegions() {
  return fromFetch(
    new Request(`${fleetEnvironment.mapSetsUrl}/availableRegions`, {
      method: 'GET',
      headers: {
        ...requiredHeaders,
        ...new FleetJwtAuthHeaders(),
      },
    })
  ).pipe(selectData(availableRegionsSchema));
}
